export enum SubscriptionStateKind {
  Subscribed = 1,
  MutedByApi = -2,
  MutedByUser = -3, // Does not exist yet
}
